var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { CustomScrollbarsContent, } from './scrollbar.styles';
import { ScrollbarTrackAndThumb } from './scrollbarTrackAndThumb';
var ScrollbarWrapper = function (_a) {
    var children = _a.children, direction = _a.direction, isFlexDisplay = _a.isFlexDisplay, idContent = _a.idContent, height = _a.height, heightDesktop = _a.heightDesktop, gabContent = _a.gabContent, loadMore = _a.loadMore, hasMore = _a.hasMore, props = __rest(_a, ["children", "direction", "isFlexDisplay", "idContent", "height", "heightDesktop", "gabContent", "loadMore", "hasMore"]);
    var contentRef = useRef(null);
    var scrollTrackRef = useRef(null);
    var scrollThumbRef = useRef(null);
    var observer = useRef(null);
    var _b = useState(20), thumbWidth = _b[0], setThumbWidth = _b[1];
    var _c = useState(20), thumbHeight = _c[0], setThumbHeight = _c[1];
    var _d = useState(null), scrollStartPosition = _d[0], setScrollStartPosition = _d[1];
    var _e = useState(0), initialScrollValue = _e[0], setInitialScrollValue = _e[1];
    var _f = useState(false), isDraggingScrollbar = _f[0], setIsDraggingScrollbar = _f[1];
    var _g = useState(false), isScrollbarVisible = _g[0], setIsScrollbarVisible = _g[1];
    function handleResize(ref) {
        setTimeout(function () {
            if (ref && contentRef.current) {
                var clientWidth = ref.clientWidth, scrollWidth = ref.scrollWidth, clientHeight = ref.clientHeight, scrollHeight = ref.scrollHeight;
                var isHorizontalScrollable = direction === 'horizontal';
                var isVerticalScrollable = direction === 'vertical';
                if (isHorizontalScrollable) {
                    var calculatedWidth = Math.max((clientWidth / scrollWidth) * clientWidth, 20);
                    setThumbWidth(calculatedWidth);
                    setIsScrollbarVisible(contentRef.current.scrollWidth > contentRef.current.clientWidth);
                }
                if (isVerticalScrollable) {
                    var calculatedHeight = Math.max((clientHeight / scrollHeight) * clientHeight, 20);
                    setThumbHeight(calculatedHeight);
                    setIsScrollbarVisible(contentRef.current.scrollHeight > contentRef.current.clientHeight);
                }
            }
        }, 500);
    }
    useEffect(function () {
        var handleWindowResize = function () {
            if (contentRef.current) {
                handleResize(contentRef.current);
            }
        };
        handleWindowResize();
        window.addEventListener('resize', handleWindowResize);
        return function () {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);
    var handleThumbPositionHorizontal = useCallback(function () {
        if (!contentRef.current ||
            !scrollTrackRef.current ||
            !scrollThumbRef.current) {
            return;
        }
        var _a = contentRef.current, contentLeft = _a.scrollLeft, contentWidth = _a.scrollWidth;
        var trackWidth = scrollTrackRef.current.clientWidth;
        var newLeft = (+contentLeft / +contentWidth) * trackWidth;
        newLeft = Math.min(newLeft, trackWidth - thumbWidth);
        var thumb = scrollThumbRef.current;
        thumb.style.left = "".concat(newLeft, "px");
    }, []);
    var handleThumbPositionVertical = useCallback(function () {
        if (!contentRef.current ||
            !scrollTrackRef.current ||
            !scrollThumbRef.current) {
            return;
        }
        var _a = contentRef.current, contentTop = _a.scrollTop, contentHeight = _a.scrollHeight;
        var trackHeight = scrollTrackRef.current.clientHeight;
        var newTop = (+contentTop / +contentHeight) * trackHeight;
        newTop = Math.min(newTop, trackHeight - thumbHeight);
        var thumb = scrollThumbRef.current;
        thumb.style.top = "".concat(newTop, "px");
    }, []);
    var handleThumbMouseup = useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (isDraggingScrollbar) {
            setIsDraggingScrollbar(false);
        }
    }, [isDraggingScrollbar]);
    var handleThumbMousemove = useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (isDraggingScrollbar && contentRef.current) {
            var _a = contentRef.current, contentScrollWidth = _a.scrollWidth, contentOffsetWidth = _a.offsetWidth, contentScrollHeight = _a.scrollHeight, contentOffsetHeight = _a.offsetHeight;
            var newScrollValue = void 0;
            if (direction === 'horizontal') {
                var deltaX = (e.clientX - scrollStartPosition) *
                    (contentOffsetWidth / thumbWidth);
                newScrollValue = Math.min(initialScrollValue + deltaX, contentScrollWidth - contentOffsetWidth);
                contentRef.current.scrollLeft = newScrollValue;
            }
            else {
                var deltaY = (e.clientY - scrollStartPosition) *
                    (contentOffsetHeight / thumbHeight);
                newScrollValue = Math.min(initialScrollValue + deltaY, contentScrollHeight - contentOffsetHeight);
                contentRef.current.scrollTop = newScrollValue;
            }
        }
    }, [isDraggingScrollbar, scrollStartPosition, thumbHeight, initialScrollValue]);
    useEffect(function () {
        var handleContentScroll = function () {
            if (direction === 'horizontal') {
                handleThumbPositionHorizontal();
            }
            else {
                handleThumbPositionVertical();
            }
        };
        if (contentRef.current) {
            var ref_1 = contentRef.current;
            observer.current = new ResizeObserver(function () {
                handleResize(ref_1);
            });
            observer.current.observe(ref_1);
            ref_1.addEventListener('scroll', handleContentScroll);
            return function () {
                var _a;
                (_a = observer.current) === null || _a === void 0 ? void 0 : _a.unobserve(ref_1);
                ref_1.removeEventListener('scroll', handleContentScroll);
            };
        }
    }, []);
    useEffect(function () {
        if (isDraggingScrollbar) {
            document.addEventListener('mousemove', handleThumbMousemove);
            document.addEventListener('mouseup', handleThumbMouseup);
            document.addEventListener('mouseleave', handleThumbMouseup);
        }
        return function () {
            document.removeEventListener('mousemove', handleThumbMousemove);
            document.removeEventListener('mouseup', handleThumbMouseup);
            document.removeEventListener('mouseleave', handleThumbMouseup);
        };
    }, [isDraggingScrollbar, handleThumbMousemove, handleThumbMouseup]);
    var handleScroll = useCallback(function () {
        if (!contentRef.current)
            return;
        var _a = contentRef.current, scrollTop = _a.scrollTop, clientHeight = _a.clientHeight, scrollHeight = _a.scrollHeight;
        if (scrollTop + clientHeight >= scrollHeight && hasMore) {
            loadMore && loadMore();
            if (direction === 'vertical') {
                contentRef.current.scrollTop = contentRef.current.scrollHeight;
            }
        }
    }, [hasMore, loadMore, direction]);
    useEffect(function () {
        if (!contentRef.current)
            return;
        contentRef.current.addEventListener('scroll', handleScroll);
        return function () {
            if (!contentRef.current)
                return;
            contentRef.current.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);
    useEffect(function () {
        if (contentRef.current) {
            handleResize(contentRef.current);
        }
    }, [children]);
    var ContentWraperStyles = function (flexWrapStyle) {
        return (_jsx("div", __assign({ style: __assign({ display: 'flex', gap: gabContent }, flexWrapStyle) }, { children: children })));
    };
    var FlexWrap = ContentWraperStyles({ flexWrap: 'nowrap' });
    var GridWrap = ContentWraperStyles({ flexWrap: 'wrap' });
    return (_jsxs("div", __assign({ style: { position: 'relative' } }, { children: [_jsx(CustomScrollbarsContent, __assign({ "$direction": direction, ref: contentRef, id: idContent, "$height": height, "$heightDesktop": heightDesktop, "$isScrollbarVisible": isScrollbarVisible }, props, { children: isFlexDisplay ? FlexWrap : GridWrap })), isScrollbarVisible && _jsx(ScrollbarTrackAndThumb, { direction: direction, contentRef: contentRef, scrollTrackRef: scrollTrackRef, thumbWidth: thumbWidth, thumbHeight: thumbHeight, isDraggingScrollbar: isDraggingScrollbar, scrollThumbRef: scrollThumbRef, setScrollStartPosition: setScrollStartPosition, setInitialScrollValue: setInitialScrollValue, setIsDraggingScrollbar: setIsDraggingScrollbar })] })));
};
export default ScrollbarWrapper;
